import { Link } from 'react-router-dom';

export default function AccountDeletion() {
  return (
    <main className="policy">
      <div className="policy__container">
        <div className="policy__back">
          <Link to="/" className="policy__back-link">← Back to Home</Link>
        </div>

        <h1 className="policy__title">Account &amp; Data Deletion Request</h1>
        <p className="policy__updated">Last updated: July 2, 2026</p>

        <p>This page explains how to request deletion of your account and associated personal data from the <strong>Hoam Facility</strong> mobile application, operated by <strong>HOAM Facility Management (Pvt) Ltd</strong>, Islamabad, Pakistan.</p>

        <h2>How to Request Deletion</h2>
        <p>Because the Hoam Facility app is provided to residents, property owners, tenants, and employees of Giga City, account deletion is handled manually by our team to verify your identity and protect community records. To request deletion of your account and personal data:</p>
        <ul>
          <li>Send an email to <a href="mailto:contact@hoamfacility.com?subject=Account%20Deletion%20Request">contact@hoamfacility.com</a> from the email address registered on your account.</li>
          <li>Use the subject line <strong>"Account Deletion Request"</strong>.</li>
          <li>Include your <strong>registered username</strong> and <strong>CNIC number</strong> so we can verify your identity.</li>
          <li>Mention the phone number registered with your account, if available.</li>
        </ul>
        <p>You may also submit your request by calling our office at <a href="tel:+92514918333">+92 51 4918333</a> during office hours (Monday – Saturday, 9:00 AM – 6:00 PM).</p>
        <p>Once we receive and verify your request, we will process it within <strong>30 days</strong> and confirm completion by email.</p>

        <h2>What Data Is Deleted</h2>
        <p>Upon verification of your request, we will delete or anonymize the following personal data associated with your account:</p>
        <ul>
          <li>Your account login credentials and profile information (name, email address, phone number, username).</li>
          <li>Profile photos and documents you uploaded through the app.</li>
          <li>Guest access records and OTPs generated by you.</li>
          <li>Maintenance requests, complaints, and in-app communications, to the extent they are not required for the records described below.</li>
          <li>App usage data and device identifiers linked to your account.</li>
        </ul>

        <h2>What Data Is Retained (and For How Long)</h2>
        <p>As a licensed facility-management company, we are legally and contractually required to keep certain records even after an account is deleted. Deleting your app account does <strong>not</strong> remove these records. We retain the following:</p>
        <ul>
          <li><strong>Owner, tenant, and employee records</strong> — including identity details (such as CNIC), unit/property association, tenancy or employment history, and related documents — are retained for as long as required by applicable Pakistani law and regulatory obligations, and in any case for up to <strong>7 years</strong> after the end of your relationship with the community.</li>
          <li><strong>Financial and billing records</strong> — invoices, payments, receipts, and accounting entries — are retained for up to <strong>7 years</strong> to comply with tax, audit, and accounting requirements.</li>
          <li><strong>Records required to establish, exercise, or defend legal claims</strong>, or to comply with a legal obligation or a valid request from a public authority, are retained for as long as necessary for those purposes.</li>
        </ul>
        <p>Where we no longer need personal data for these purposes, we securely delete or anonymize it. Residual copies may remain in encrypted backups and are not restored except for security, disaster recovery, or legal compliance.</p>

        <h2>Contact Us</h2>
        <p>If you have any questions about deleting your account or data, you can contact us:</p>
        <ul>
          <li>By email: <a href="mailto:contact@hoamfacility.com">contact@hoamfacility.com</a></li>
          <li>By phone: <a href="tel:+92514918333">+92 51 4918333</a></li>
          <li>By mail: HOAM Facility Management (Pvt) Ltd, Downtown Giga, DHA Phase 2, Islamabad, Pakistan</li>
        </ul>
        <p>For more information on how we handle your data, please see our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
      </div>
    </main>
  );
}
